// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3XYKf","errorLogs":"styles_errorLogs__2VSRU"};